import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=108353e2&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=ts"
export * from "./FilterItem.vue?vue&type=script&lang=ts"
import style0 from "./FilterItem.vue?vue&type=style&index=0&id=108353e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108353e2",
  null
  
)

export default component.exports